module.exports = __webpack_public_path__ + "img/say-yes.ca241bb3.svg";